import { BfkeyAPI } from '../api/BfkeyAPI';

export const BfkeyRepository = {
  getBfKey: () => BfkeyAPI.getBfKey()
};